<template>
  <div style="height: 100%">
    <div class="loading-wrapper" v-if="loading">
      <Loading class="center c-center" type="spinner" color="#2faeff" vertical
        >加载中...</Loading
      >
    </div>
    <div
      id="poster"
      class="result-wrap result-new"
      :class="[isNormal ? 'result-wrap-normal' : 'result-wrap']"
    >
      <!-- 自定义的背景 -->
      <div class="rule">
        <!-- <Button @click="showLeaderBoard = true" class="btn">排名</Button> -->
      </div>
      <div class="infos">
        <div class="infos-title">恭喜您成为</div>
        <div class="infos-text2">
          第
          <span v-if="!loading" class="infos-tip-text">{{
            resInfo?.total + 10000
          }}</span>
          名
        </div>
        <div class="infos-tip">
          为祖国庆生的公民
        </div>
      </div>
      <div class="qrcode-wrap">
        <img class="qrcode" :src="qrcodeUrl" alt="" />
      </div>
      <div v-show="show" class="pop_wrap">
        <div class="img-wrap"></div>
        <p class="share-tips">长按保存图片分享朋友圈</p>
      </div>
    </div>
    <!-- @click="handleJump2Home" -->
    <Button class="finsh-btn" @click="showPopup">为祖国庆生</Button>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
import { Button, Loading } from 'vant'
import { reactive, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import qs from 'qs'
import { useCommonLotteryEffect } from '@/effects/lotteryClickEffect'
import { useCommonStyleEffect } from '@/effects/styleConfigEffect'
import { getQueryString } from '@/utils/tools'
import { getResult } from '@/api/index'

// 初始化配置
const optionEffect = () => {
  const store = useStore()
  const quesSetting = store.getters.getQuesSetting

  let showType = 'none'
  if (quesSetting.scoreShow === 2 && quesSetting.rankShow === 2) {
    showType = 'all'
  } else if (quesSetting.scoreShow === 2) {
    showType = 'score'
  } else if (quesSetting.rankShow === 2) {
    showType = 'rank'
  } else {
    showType = 'none'
  }

  return {
    showType
  }
}

// qrcode
const useQrcodeEffect = () => {
  const qrcodeUrl = ref('')
  const generateQR = async text => {
    try {
      qrcodeUrl.value = await QRCode.toDataURL(text)
    } catch (err) {
      console.error(err)
    }
  }

  const route = useRoute()

  // questionActiveKey=5e7637e36a9b42dc889664b1acb050bb&isPreview=0&activeId=&unitId=&type=gq
  onMounted(() => {
    generateQR(`
    https://app-survey.iqilu.com/h5/#/competition/home?questionActiveKey=${route.query.questionActiveKey}&orgid=${route.query.orgid}&type=gq
    `)
  })

  return {
    qrcodeUrl
  }
}

export default {
  components: {
    Button,
    Loading
  },
  setup() {
    const { qrcodeUrl } = useQrcodeEffect()
    const show = ref(false)
    const showPopup = () => {
      show.value = true
    }
    const loading = ref(true)

    const route = useRoute()
    const router = useRouter()
    const resInfo = reactive({
      score: undefined,
      rank: undefined,
      rightCount: 0,
      lotteryUrl: '',
      rowNum: 0,
      total: '',
      totalCount: 0
    })

    let { showType } = optionEffect()
    // 判断练习还是正式考试
    const resultType = route.query.resultType
      ? parseInt(route.query.resultType)
      : 1

    const isPreview = route.query.isPreview
      ? parseInt(route.query.isPreview)
      : 1

    if (resultType === 2) {
      showType = 'score'
    }

    // 再次答题
    const activeId = getQueryString('activeId')
    const unitId = getQueryString('unitId')
    const handleJump2Home = () => {
      router.replace(
        `/competition/home?questionActiveKey=${route.query.questionActiveKey}&isPreview=${isPreview}&activeId=${activeId}&unitId=${unitId}`
      )
    }
    const handlePoster = () => {}

    // 抽奖点击
    const { handleLotteryClick } = useCommonLotteryEffect(resInfo)

    // 排行榜显示
    const showLeaderBoard = ref(false)

    // 设置样式
    const { isNormal } = useCommonStyleEffect()

    // 获取考试结果
    const resultInfoEffect = (resInfo, resultType) => {
      const route = useRoute()
      const store = useStore()
      const text = ref('您已完成答题, 感谢参与！')

      const getResultInfo = async () => {
        const res = await getResult(
          qs.stringify({
            questionActiveKey: route.query.questionActiveKey,
            type: resultType,
            token: store.getters.getToken,
            answerGroupKey: route.query.answerGroupKey
          })
        )
        loading.value = false
        resInfo.score = res.data.score
        resInfo.longTime = res.data.longTime
        resInfo.rank = res.data.rank
        resInfo.rightCount = res.data.rightCount
        resInfo.rowNum = res.data.rowNum
        resInfo.total = res.data.total
        resInfo.totalCount = res.data.totalCount
        resInfo.lotteryUrl = res.data.lotteryUrlNew || res.data.lotteryUrl
        console.log(res)
        // TEMP
        const poster = document.getElementById('poster')
        setTimeout(() => {
          html2canvas(poster, {
            // allowTaint: true
            useCORS: true
          }).then(function(canvas) {
            var img = new Image()
            img.crossOrigin = 'anonymous'
            img.src = canvas.toDataURL('image/png')
            img.style.width = '100%'
            img.style.height = '100%'
            document.querySelector('.img-wrap').appendChild(img)
          })
        }, 0)
      }

      getResultInfo()

      return {
        text
      }
    }

    const { text } = resultInfoEffect(resInfo, resultType)

    return {
      resInfo,
      resultType,
      text,
      showType,
      handleJump2Home,
      showLeaderBoard,
      handleLotteryClick,
      isNormal,
      handlePoster,
      qrcodeUrl,
      show,
      showPopup,
      loading
      // getResultInfo,
    }
  }
}
</script>
<style lang="scss" scoped>
.result-wrap {
  width: 100%;
  min-height: 100vh;
  background: no-repeat center/100%
    url('../../assets/img/competition/home-bg-party.png')
}
.result-wrap-normal {
  background: no-repeat center/100%
    url('../../assets/img/competition/home-bg-normal.png');
  // .infos-detail {
  //   background-color: rgba(128,197,89, 0.2) !important;
  // }

  h1.infos-text,
  .infos .infos-detail .infos-detail-item div,
  .infos .infos-detail .infos-detail-item div.grey {
    color: #30afff;
  }
  .infos .infos-detail {
    display: flex;
    align-items: center;
    height: 200px;
    background-color: rgba(255, 255, 255, 0.5);
    background: hsla(0, 0%, 100%, 0.8);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    border: 1px solid #fff;

    div.grey {
      opacity: 0.9 !important;
    }
  }
}
.rule {
  text-align: right;
  padding-top: 80px;
  .btn {
    margin-top: 50px;
    margin-right: 40px;
    min-width: 118px;
    height: 48px;
    background: #f7fbfe;
    box-shadow: 0px 0px 10px 0px rgba(47, 117, 182, 0.1);
    opacity: 0.6;
    border-radius: 23px;
    font-size: 28px;
    color: #eb5046;
  }
}
.result {
  margin: 0 auto;
  width: 293px;
  height: 282px;
  line-height: 301px;
  text-align: center;
  background: no-repeat top/100%
    url('../../assets/img/competition/result-icon.png');
  font-size: 72px;
  font-weight: bold;
  color: #ffffff;

  .none-img {
    position: relative;
    top: 15px;
    width: 105px;
    height: 113px;
  }
}
.infos {
  margin: 0 auto;
  margin-top: 40px;

  .infos-text {
    text-align: center;
    margin: 0;
    font-size: 36px;
    color: #ffffff;
  }

  .infos-detail {
    margin: 0 auto;
    margin-top: 27px;
    width: 650px;
    height: 187px;
    text-align: center;
    background-color: rgba(187, 47, 41, 0.2);

    .infos-detail-item {
      display: flex;
      flex-wrap: wrap;
      font-size: 32px;
      font-weight: 500;

      div {
        color: #fff;
        height: 84px;
        line-height: 84px;
      }
      div.grey {
        color: #fff;
        opacity: 0.8;
      }

      .wrap1 {
        width: 100%;
      }
      .wrap2 {
        width: 50%;
      }
      .wrap3 {
        width: 33.3%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

.lottery {
  margin-left: 106px;
  margin-top: 38px;
  width: 583px;
  height: 484px;
  background: no-repeat top/100%
    url('../../assets/img/competition/result-lottery.png');

  .content {
    margin-left: 149px;
    width: 253px;
    .text {
      margin: 0;
      text-align: center;
      padding-top: 226px;
      font-size: 34px;
      line-height: 1.2;
      font-weight: bold;
      color: #222222;
    }
    .btn {
      margin-top: 41px;
      width: 253px;
      height: 63px;
      background: linear-gradient(0deg, #ff615d, #fe4342);
      border-radius: 31px;
      font-size: 32px;
      color: #ffffff;
    }
  }
}

.finsh-btn {
  display: block;
  margin: 0 auto;
  margin-top: 55px;
  width: 433px;
  height: 111px;
  background: linear-gradient(0deg, #ff9c2e, #ffde3a);
  box-shadow: 0px 1px 10px 0px rgba(254, 167, 74, 0.57);
  border-radius: 56px;
  border: none;
  font-size: 42px;
  font-weight: bold;
  color: #ffffff;
  position: fixed;
  z-index: 666;
  bottom: 50px;
  left: 0;
  right: 0;
}

.hasLottery {
  margin-top: 400px;
}

// 排行榜
.leaderboard-title {
  position: absolute;
  margin: 0 auto;
  top: -45px;
  left: 0;
  right: 0;
  width: 503px;
  height: 96px;
  line-height: 96px;
  background: no-repeat center/100%
    url('../../assets/img/competition/leaderboard.png');
  color: #fff;
  font-size: 36px;
  text-align: center;
}
.leaderboard-list {
  margin-left: 39px;
  margin-right: 49px;
  margin-top: 40px;
  padding-bottom: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    height: 148px;
    padding: 42px 0 39px 0;
    border-bottom: 1px solid rgba(0, 130, 251, 0.2);

    .left {
      display: flex;
      align-items: center;
      height: 100%;
      .index {
        font-size: 36px;
        color: #2897ff;
      }
      .img {
        margin-left: 40px;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background-color: #ccc;
      }
      .info {
        margin-left: 41px;
        p {
          margin: 0;
        }
        .name {
          margin-bottom: 14px;
          font-size: 34px;
          font-weight: 400;
          color: #333333;
        }
        .more {
          font-size: 26px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .right {
      font-size: 36px;
      font-weight: 400;
      color: #1382ff;
    }
  }
}
</style>
<style>
.van-action-sheet,
.van-popup {
  overflow: visible !important;
}
</style>
<style scoped>
.result-new {
  box-sizing: border-box;
  padding-top: 600px;
  background: no-repeat center 0/100%
    url('../../assets/img/competition/bg-result-new.jpg');
}
.infos {
  text-align: center;
  color: #ffe6c4;
}
.infos-title {
  font-size: 46px;
  color: #ffe6c4;
  margin-bottom: 20px;
}
.infos-text2 {
  font-size: 56px;
  color: #ffe6c4;
  margin-bottom: 20px;
}
.infos-tip {
  font-size: 46px;
}
.infos-tip-text {
  font-size: 46px;
  color: #fff;
}
.qrcode-wrap {
  text-align: center;
  font-size: 24px;
  color: #fff;
  margin-top: 200px;
}
.qrcode {
  width: 160px;
  height: 160px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.tip-text {
  color: #333;
  font-size: 14px;
}
.text-wrap .tip-text {
  color: #fff;
}
.pop_wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 888;
  background-color: rgba(0, 0, 0, 0.5);
}
.c-center {
  margin: auto;
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: center;
}

.loading-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
}
.share-tips {
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;
  font-size: 14px;
  color: #fff;
  text-align: center;
}

@media screen and (max-height: 736px) {
  .qrcode-wrap {
    margin-top: 50px;
  }
  .finsh-btn {
    bottom: 50px;
  }
}
</style>
